<template>
	<div>
		<article class="iv2-article" v-if="pageActive">
			<LayoutTitle :news="news" />
			<LayoutList :news="news" />
		</article>
		<div v-if="loading">
			<BaseLoading />
		</div>
	</div>
</template>

<script>
import LayoutTitle from "./components/LayoutTitle.vue";
import LayoutList from "./components/LayoutList.vue";
import BaseLoading from "@/components/item/BaseLoading.vue";

import Meta from "@/mixins/MetaSettable";

export default {
	mixins: [Meta],

	props: ["animation"],

	components: {
		LayoutTitle,
		LayoutList,
		BaseLoading
	},

	data() {
		return {
			news: [],
			pageActive: false,
			loading: true
		};
	},

	created() {
		this.axios.get("/json/news_list.json").then(response => {
			this.news = response.data.news;
			this.loading = false;
			this.pageActive = true;
		});
	},

	mounted() {
		this.$ga.page("/news");
	}
};
</script>

<style lang="scss">
</style>